var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Address"},[_c('Form',{attrs:{"form":_vm.form,"data":_vm.formData},on:{"change":_vm.onChange}}),_c('Button',{attrs:{"disabled":_vm.isDisabled()},on:{"click":_vm.onSendAddress}},[_vm._v("送信する")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }